/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ExportSampleInstructions$Params {
  bpGuid: string;
  isDomestic: boolean;
  secCode?: string;
  timezoneOffset: number;
}

export function exportSampleInstructions(http: HttpClient, rootUrl: string, params: ExportSampleInstructions$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, exportSampleInstructions.PATH, 'post');
  if (params) {
    rb.query('bpGuid', params.bpGuid, {});
    rb.query('isDomestic', params.isDomestic, {});
    rb.query('secCode', params.secCode, {});
    rb.query('timezoneOffset', params.timezoneOffset, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/pdf', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

exportSampleInstructions.PATH = '/exports/sample-instructions';
